import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './faq.component.scss'
})
export class FAQComponent {

}
